// Types
import { GetStream_stream } from 'api/streams/types/GetStream';

export const getIsInterview = (stream: GetStream_stream): boolean => {
  return stream?.isInterview || false;
};
